export default __webpack_public_path__ + "static/media/20_mobile.90036f23.jpg";